import { action, makeObservable, observable } from 'mobx';

export class SectionSettings<TSettingsType extends object = object> {
  @observable settingsId: number | null = null;
  @observable.ref settings: TSettingsType | null = null;
  @observable isInitialSettingsLoading = false;
  @observable isUpdatingSettings = false;

  constructor(initialSettings?: TSettingsType) {
    this.settings = initialSettings ?? null;

    makeObservable(this);
  }

  @action.bound
  setSettings(settings: TSettingsType): void {
    this.settings = settings;
  }

  @action.bound
  setSettingsId(id: number): void {
    this.settingsId = id;
  }

  @action.bound
  setIsInitialSettingsLoading(isLoading: boolean): void {
    this.isInitialSettingsLoading = isLoading;
  }

  @action.bound
  setIsUpdatingSettings(isUpdating: boolean): void {
    this.isUpdatingSettings = isUpdating;
  }
}
